import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-multiselect-modal',
  templateUrl: './multiselect-modal.component.html',
  styleUrls: ['./multiselect-modal.component.scss']
})
export class MultiselectModalComponent {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: any;
  @Input() SHOW_CLEAN_BTN = true;
  @Input() DATA_CHANGE = true;
  @Input() DESTINY_CHANGE: { name: any, value: any };
  @Input() HEADERS_LABELS: {
    title: string;
    subtitle: string;
  } = {
      title: 'deporte.title-sport',
      subtitle: 'deporte.text-sport'
    };
  /**
   * @ignore
   */
  constructor() { }

}
